module.exports = __webpack_public_path__ + "c69f1dac95b65ef2f4b904adf8c66710.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/rockers-hat.jpg
 ** module id = 456
 ** module chunks = 0
 **/